import * as React from "react";
import { Button, Flex, Heading } from "@aws-amplify/ui-react";
import { Container, Card } from 'react-bootstrap';
import { useNavigate, useLocation } from "react-router-dom";

export default function GolfResults() {
  const navigate = useNavigate();
  const location = useLocation();
  const players = location.state?.players || [];
  const completedRounds = location.state?.completedRounds || [];

  // Sort players by score (lowest is best in Golf)
  const sortedPlayers = [...players].sort((a, b) => a.total - b.total);

  const getPlacementText = (index) => {
    if (index === 0) return "🥇 1st Place";
    if (index === 1) return "🥈 2nd Place";
    if (index === 2) return "🥉 3rd Place";
    return `${index + 1}th Place`;
  };

  return (
    <Container className="mt-3">
      <Card className="mb-4 text-center">
        <Card.Body>
          <Heading level={2}>Game Over!</Heading>
          <p className="text-muted mb-0">
            {completedRounds.length} round{completedRounds.length !== 1 ? 's' : ''} played
          </p>
        </Card.Body>
      </Card>

      {/* Final Rankings */}
      <Card className="mb-4">
        <Card.Body>
          <Card.Title>Final Rankings</Card.Title>
          <div>
            {sortedPlayers.map((player, index) => (
              <div key={player.id} className="mb-3 p-3 border-bottom">
                <div className="d-flex justify-content-between align-items-center">
                  <div>
                    <h5 className="mb-1">{getPlacementText(index)}</h5>
                    <p className="mb-0 text-muted">{player.name}</p>
                  </div>
                  <div className="text-end">
                    <h4 className="mb-0">{player.total}</h4>
                    <small className="text-muted">
                      ({player.scores.length} rounds)
                    </small>
                  </div>
                </div>
              </div>
            ))}
          </div>
        </Card.Body>
      </Card>

      {/* Score Breakdown */}
      <Card className="mb-4">
        <Card.Body>
          <Card.Title>Score Breakdown</Card.Title>
          <div>
            {sortedPlayers.map(player => (
              <div key={player.id} className="mb-4">
                <h6 className="mb-2">{player.name}</h6>
                <div className="d-flex flex-wrap gap-2 mb-2">
                  {player.scores.map((score, roundIndex) => (
                    <span key={roundIndex} className="badge bg-info">
                      R{roundIndex + 1}: {score}
                    </span>
                  ))}
                </div>
                <div className="d-flex justify-content-between">
                  <span>Total:</span>
                  <strong>{player.total}</strong>
                </div>
              </div>
            ))}
          </div>
        </Card.Body>
      </Card>

      {/* Action Buttons */}
      <Flex justifyContent="center" gap="10px" className="mb-4">
        <Button
          children="Play Again"
          onClick={() => navigate("/golf")}
          variation="primary"
        />
      </Flex>
    </Container>
  );
}
